import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import { Capacitor } from '@capacitor/core';
import { Platform } from '../models/platform.enum';

export const CURRENT_PLATFORM: Platform = Capacitor.getPlatform() as Platform;

@Injectable({
  providedIn: 'root',
})
export class EnvService {
  private readonly apiUrl: string = '';
  private readonly tunnelApiUrl: string = '';
  private readonly fileUploadApiUrl: string = '';
  readonly production: boolean = false;


  constructor() {
    this.apiUrl = environment.apiUrl;
    this.tunnelApiUrl = environment.tunnelUrl;
    this.fileUploadApiUrl = environment.fileUploadUrl;
    this.production = environment.production;

    API_BASE_URL = this.apiUrl;
    TUNNEL_BASE_URL = this.tunnelApiUrl;
    FILE_UPLOAD_BASE_URL = this.fileUploadApiUrl;
  }

  /**
   * Check if the app is running in a web browser
   * @returns boolean indicating if running in web browser
   */
  public isWeb(): boolean {
    return Capacitor.getPlatform() === Platform.WEB;
  }
}

export let API_BASE_URL = '';
export let TUNNEL_BASE_URL = '';
export let FILE_UPLOAD_BASE_URL = '';
